import React from "react";
import Modal from "../Modal/Modal";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import goldenLogo from "../../../../assets/logos/golden-logo.svg";
import Button from "../../Button/Button";
import styles from "./PaymentCompleted.module.scss";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes";
import Tooltip from "../../Tooltip/Tooltip";
import CopyBtn from "../../CopyBtn/CopyBtn";


const PaymentCompleted = ({
  show,
  handleClose,
  closeCart,
  txnId,
  paymentType,
}) => {
  const navigate = useNavigate();

  // const handleCheck = () => {
  //   let route = ROUTES.MY_ORDERS;
  //   let state = {};
  //   if (paymentType === "REDEEM") {
  //     route = ROUTES.TRANSACTIONS_OPENED;
  //   } else if (paymentType === "MARKETPLACE") {
  //     route = ROUTES.TRANSACTIONS_OPENED;
  //     state = { activeTab: "marketplace" };
  //   } else {
  //     state = { tab: paymentType.toLowerCase() };
  //   }

  //   navigate(route, { state });

  //   handleClose();
  //   if (closeCart) closeCart();
  // };


  const handleCheck = () => {
    let route = ROUTES.TRANSACTIONS_OPENED;
    let state = {};

    if (paymentType === "REDEEM") {
      state = { activeTab: "redeem" };
    } else if (paymentType === "MARKETPLACE") {
      state = { activeTab: "marketplace" };
    } else {
      route = ROUTES.MY_ORDERS;
      state = { tab: paymentType?.toLowerCase() };
    }

    navigate(route, { state, replace: true });

    handleClose();
    if (closeCart) closeCart();
  };



  //   const handleCheck = () => {
  //   navigate(ROUTES.TRANSACTIONS_OPENED, {
  //     state: { activeTab: "marketplace" },
  //     replace: true
  //   });
  //   handleClose();
  //   if (closeCart) closeCart();
  // };

  return (
    <Modal
      show={show}
      title={
        <span onClick={handleClose}>
          <LeftArrowIcon /> Back
        </span>
      }
      hideCloseBtn
      handleClose={handleClose}
      className={styles.payment_complete}
    >
      <img className={styles.logo} src={goldenLogo} alt="gold-stbl" />
      <h3>Your Transaction is Complete!</h3>
      <p>Your transaction has been successfully processed.</p>
      {txnId && (
        <h6>
          Transaction Id:{" "}
          <Tooltip
            icon={<span>{txnId}</span>}
            content={
              <>
                <CopyBtn text={txnId} /> {txnId}
              </>
            }
          />
        </h6>
      )}
      <Button className={styles.check_btn} fluid onClick={handleCheck}>
        Check Details
      </Button>
    </Modal>
  );
};

export default PaymentCompleted;
